import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Nav, Icon } from '@beisen/chaos-ui';
import * as helper from '../util/helper';
const customApp = window.env.platform.weixin || window.env.platform.dingTalk;
// 安卓init初始化
window.env.initEvent();

export default class BSNav extends Component {
    constructor(props) {
        super(props);
        window.globalEventManager = window.globalEventManager || {};
        window.globalEventManager['handleClose'] =
            this.props.handleClose || helper.redirectApp;
        window.globalEventManager['handleBack'] =
            this.props.handleBack || helper.handleBack;
        this.isElink = helper.isElink();
    }
    // 在钉钉和微信中 隐藏关闭和返回的两种情况： 1.列表页视图大于一个  2.详情页
    isHideBackAndClose() {
        const viewsLength = this.props.navViewsLength || 0;
        return customApp && (this.props.isDetail || viewsLength > 1);
    }

    hasBack() {
        return !this.props.noSysBack && !this.isHideBackAndClose();
    }

    hasClose() {
        return (
            helper.isNeedClose() &&
            !this.props.noSysClose &&
            !this.isHideBackAndClose()
        );
    }

    // 调用app 方法来更新导航
    changeHeader(headerConfig) {
        if (window.inPopup) return;
        const config = this.formatHeaderConfig(headerConfig);
        //将导航信息存储到栈里面
        helper.setBaseHeaderConfig(config);
        const detailNav = ReactDOM.findDOMNode(this);
        window.env.platform.select({
            beisenApp() {
                window.env.configNavigation(config, ret => {
                    window.BSnav &&
                        window.BSnav.closePop &&
                        window.BSnav.closePop(); // 点击导航 关闭toolbar弹层
                    const itemData = ret && ret.data;
                    if (!itemData) return;
                    const { callback, control } = itemData;
                    if (control && callback) {
                        window.globalEventManager[callback]();
                    }
                });
            },
            mobile() {
                if (config) {
                    if (detailNav) {
                        const navCenter = detailNav.getElementsByClassName(
                            'nav-center'
                        )[0];
                        const navTitle = detailNav.getElementsByClassName(
                            'nav-title'
                        )[0];
                        if (config.bgColor) {
                            detailNav.style.background = config.bgColor;
                        }
                        if (config.color) {
                            detailNav.style.color = config.color;
                        }
                        if (
                            config.titleItem &&
                            config.titleItem.color &&
                            navTitle
                        ) {
                            navTitle.style.color = config.titleItem.color;
                            navCenter &&
                                (navCenter.style.color =
                                    config.titleItem.color);
                        }
                    }
                    return;
                }
            }
        });
    }

    formatHeaderConfig(headerColor) {
        let headerConfig = {
            bgColor: '#fafafa', // 导航背景色
            leftItem: [],
            titleItem: { color: '#3A4247' }, // 标题颜色
            rightItem: [],
            color: '#6B7175' // 图标颜色
        };

        /**------------h5------------ */
        if (headerColor && !window.env.platform.beisenApp) return headerColor;

        /**------------以下为app中导航配置--------------- */

        if (window.env.platform.beisenApp && headerColor) {
            headerConfig = Object.assign({}, headerConfig, headerColor);
        }

        const { handleBack, handleClose } = this.props;

        if (this.hasBack()) {
            const item = {
                type: 'back',
                callback: 'handleBack',
                control: handleBack ? true : false
            };
            headerConfig.leftItem.push(item);
        }

        if (this.hasClose()) {
            const item = {
                type: 'close',
                callback: 'handleClose',
                control: handleClose ? true : false
            };
            headerConfig.leftItem.push(item);
        }

        // 导航标题
        if (this.props.title) {
            headerConfig.titleItem = Object.assign(headerConfig.titleItem, {
                text: this.props.title
            });
        }

        // 处理nav的children生成config
        React.Children.forEach(this.props.children, item => {
            if (item && item.props) {
                //头部中间数据组织逻辑
                /*------------注意：title和role: center是互斥的 只能显示一个------------- */
                if (item.props.role == 'center' && !this.props.title) {
                    if (item.props.cmp_type) {
                        headerConfig.titleItem = Object.assign(
                            {
                                text:
                                    (item.props.biz_data &&
                                        item.props.biz_data[
                                            item.props.cmp_data.currentViewName
                                        ] &&
                                        item.props.biz_data[
                                            item.props.cmp_data.currentViewName
                                        ].text) ||
                                    '',
                                control: true,
                                icon: '',
                                callback: 'showDropDown'
                            },
                            headerConfig.titleItem
                        );
                    } else {
                        let centerTitle = '';
                        if (typeof item.props.children == 'string') {
                            centerTitle = item.props.children;
                        } else if (item.props.children) {
                            if (
                                item.props.children.constructor.name == 'Array'
                            ) {
                                centerTitle = item.props.children.join('');
                            } else if (
                                item.props.children.constructor.name == 'Object'
                            ) {
                                centerTitle =
                                    item.props.children.props &&
                                    item.props.children.props.children;
                            }
                        }
                        headerConfig.titleItem = Object.assign(
                            headerConfig.titleItem,
                            {
                                text: centerTitle
                            }
                        );
                    }
                }
                //头部右侧数据组织
                if (item.props.role == 'right') {
                    React.Children.forEach(
                        item.props.children,
                        (iconItem, index) => {
                            if (
                                iconItem.props &&
                                (iconItem.props.icon || iconItem.props.text)
                            ) {
                                headerConfig.rightItem.push({
                                    icon: iconItem.props.icon,
                                    callback: iconItem.props.callback,
                                    text: iconItem.props.text,
                                    control: true,
                                    style: iconItem.props.style
                                });
                            }
                        }
                    );
                }
            }
        });
        return headerConfig;
    }

    componentDidMount() {
        this.changeHeader(this.props.headerColor);
    }

    componentDidUpdate() {
        if (!window.inPopup) {
            this.changeHeader(this.props.headerColor);
        }
    }

    // 不显示导航的情况： 1.iOS app 2.android app 3.微信和钉钉的列表页  视图只有一个或没有时 4.微信和钉钉的详情页没有右侧图标时
    hideNav() {
        const { isDetail, hasRightIcon } = this.props;
        const navViewsLength = this.props.navViewsLength || 0;
        return (
            window.env.platform.beisenApp ||
            (customApp &&
                ((navViewsLength < 2 && !isDetail) ||
                    (!hasRightIcon && isDetail)))
        );
    }

    render() {
        // 内置返回与关闭  可设置属性使其不显示
        const displayNone = { display: 'none' };
        return (
            <Nav
                style={this.hideNav() ? displayNone : this.props.style}
                {...this.props}>
                {!this.isElink && (
                    <div role="left">
                        <Icon
                            icon="m-sys-backward"
                            style={this.hasBack() ? {} : displayNone}
                            onTouchTap={
                                this.props.handleBack || helper.handleBack
                            }
                        />
                        <Icon
                            icon="m-sys-guanbi"
                            style={this.hasClose() ? {} : displayNone}
                            onTouchTap={
                                this.props.handleClose || helper.redirectApp
                            }
                        />
                    </div>
                )}
                {this.props.children}
            </Nav>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PageNav/Nav.js